import type { DeepPartial } from '@/types';
import type { Locale } from 'antd/es/locale';
import locale from 'antd/lib/locale/sk_SK';
import { mergeDeepRight } from 'ramda';

// NOTE: Ant design translations for SK lang are incomplete so
// feel free to add translations for what you are missing or want to customize.
// Default translations can be found here: node_modules\antd\lib\locale\default.js

export const skSK: Locale = mergeDeepRight(locale, {
  Form: {
    defaultValidateMessages: {
      required: 'Prosím zadajte ${label}', // 'Please enter ${label}'
      types: {
        email: 'Email nie je platný',
        number: '${label} musí byť číslo', // '${label} is not a valid number',
        integer: '${label} musí byť celé číslo',
      },
      number: {
        min: '${label} musí byť aspoň ${min}', // '${label} must be minimum ${min}'
        max: '${label} nesmie byť väčší ako ${max}', // '${label} must be maximum ${max}'
        range: '${label} musí byť mezi ${min} a ${max}', // '${label} must be between ${min} and ${max}'
      },
    },
  },
  Pagination: {
    items_per_page: 'záznamov',
  },
  DatePicker: {
    lang: {
      // NOTE: Ant does not offer other way to customize translations in DatePicker, long names are according to design
      shortMonths: [
        'Január',
        'Február',
        'Marec',
        'Apríl',
        'Máj',
        'Jún',
        'Júl',
        'August',
        'September',
        'Október',
        'November',
        'December',
      ],
      shortWeekDays: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
    },
  },
} as DeepPartial<Locale>) as Locale;
